import React from 'react';
import { ShieldCheck, Send, Lock, Landmark, CalendarDays, MapPin } from 'lucide-react';

const BADGES = [
  { icon: ShieldCheck, label: 'CQC Regulated' },
  { icon: Send, label: 'HMRC RTI Connected' },
  { icon: Lock, label: 'ICO Registered' },
  { icon: MapPin, label: 'UK Data Only' },
  { icon: Landmark, label: 'NEST Pension' },
  { icon: CalendarDays, label: 'Tax Year 2025/26' },
];

export default function UKTrustStrip() {
  return (
    <div className="w-full border-b border-border bg-secondary/30 px-6 py-1.5 shrink-0">
      <div className="flex items-center overflow-x-auto scrollbar-none whitespace-nowrap">
        <span className="text-[12px] mr-3 shrink-0 select-none">🇬🇧</span>
        {BADGES.map((badge, i) => (
          <React.Fragment key={badge.label}>
            <div className="flex items-center gap-1.5 shrink-0">
              <badge.icon size={10} className="text-muted-foreground" />
              <span className="text-[11px] font-500 text-muted-foreground">{badge.label}</span>
            </div>
            {i < BADGES.length - 1 && (
              <span className="mx-3 text-border text-[11px] select-none">·</span>
            )}
          </React.Fragment>
        ))}
      </div>
    </div>
  );
}
